import { IconSvg } from '@graphcommerce/next-ui'
import horn from '@graphcommerce/next-ui/icons/horn.svg'
import { Trans } from '@lingui/react'
import { Alert } from '@mui/material'

type PromotionAlertProps = {
  remainingForDiscount: number
  promotionName?: string | null
}

export function PromotionAlert({ remainingForDiscount, promotionName }: PromotionAlertProps) {
  return (
    <Alert
      icon={
        <IconSvg src={horn} size='medium' sx={(theme) => ({ color: theme.palette.text.primary })} />
      }
      severity='success'
      sx={(theme) => ({
        mb: theme.spacings.xxs,
        borderRadius: theme.shape.borderRadius / 2,
        '& .MuiAlert-message': {
          py: '6px',
        },
      })}
    >
      <Trans
        id='Add {0} more {1} to your cart for the promotion: {2}'
        values={{
          0: <strong>{remainingForDiscount}</strong>,
          1: (
            <strong>
              {remainingForDiscount <= 1 ? <Trans id='product' /> : <Trans id='products' />}
            </strong>
          ),
          2: promotionName,
        }}
      />
    </Alert>
  )
}
